import React, { useEffect, useMemo } from 'react';
import Note from '@/components/Note';
import './index.less';

const PCNote: React.FC = () => {
  const query = useMemo(() => {
    // 示例链接：https://localhost:7788/meet/pc/whiteboard?channelId=1344376309467117&appkey=924af0ee72dae9709ae339daf6c5ed82&nonce=B37F0BE1213240B5825D7D35B9DC7BA3&curTime=1638084134&checksum=1fc87f97b061a5bd6365e020e8bb76aa038f2887&whiteboardOwner=4y@corp.netease.com&uid=4y@corp.netease.com&yxuid=443072&uname=4y@corp.netease.com
    // const search = new URLSearchParams(
    //   'http://10.242.144.172:7788/meet/pc/whiteboard?devopen=1&appkey=924af0ee72dae9709ae339daf6c5ed82&nonce=9D0B1D1A277442CEB53FC244E1E50954&curTime=1715065796&checksum=2b3cf309ff72d7f6d14bc9cbe42d91d7cb12963e&whiteboardChannelId=A6645BA4776A4959B140DA3CFD76EB0B&whiteboardOwner=wb.linziqin@mesg.corp.netease.com&whiteboardOwnerUid=wb.linziqin@mesg.corp.netease.com&whiteboardOwnerDeviceId=d6c51684bf434131e9ae3811ccbc2cf1&exportable=1&exportToZh=%E4%BA%91%E7%A9%BA%E9%97%B4&exportToEn=Cloud%20Drive&exportToJa=Docs&uid=2030434'
    // );
    const search = new URLSearchParams(location.search);
    const result = {
      uid: Math.floor(Math.random() * 100000) || Number(search.get('uid')) || 0,
      uname: search.get('uname') || '',
      appkey: search.get('appkey')!,
      nonce: search.get('nonce')!,
      curTime: search.get('curTime')!,
      checksum: search.get('checksum')!,
      whiteboardChannelId: search.get('whiteboardChannelId') || '',
      originWidth: Number(search.get('originWidth')) || 0,
      originHeight: Number(search.get('originHeight')) || 0,
    };
    return result;
  }, []);

  console.log('query', query);

  if (
    !query.uid ||
    !query.uname ||
    !query.appkey ||
    !query.nonce ||
    !query.curTime ||
    !query.checksum ||
    !query.whiteboardChannelId ||
    !query.originWidth ||
    !query.originHeight
  ) {
    console.error('缺少必要参数', query);
    return null;
  }

  return <Note {...query}></Note>;
};

export default PCNote;
